import angular from 'angular';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';

// Dependencies
import '../../../../../lib/service';

// Controller
import AvailabilityModalController from './availabilityModal.controller';
import template from './availabilityModal.html';

const moduleName = 'staff.dashboardScreen.availabilityModal';
let module = angular.module(moduleName, [
  uiModal
]);

module.controller('AvailabilityModalController', AvailabilityModalController);
module.factory('showAvailabilityModal', ['$uibModal', '$q', ($uibModal, $q, date) => {
  return props => {
    let modal = $uibModal.open({
      animate: false,
      template: template,
      controller: AvailabilityModalController,
      controllerAs: 'vm',
      size: 'sm',
      resolve: {
        $q: () => $q,
        date: () => props.date
      }
    });
    return modal.result;
  };
}]);

export default module;

